<script setup lang="ts">
import type { BillingProfile } from "../api";
import Icon from "./Icon.vue";

// Pola danych nabywcy — te same przy rejestracji i w Rozliczeniach. Bez <form>:
// rodzic decyduje, kiedy i z czym wysyła. Walidacja (NIP, kod pocztowy) jest na
// serwerze i to on jest źródłem prawdy; tu tylko podpowiedzi.

const model = defineModel<BillingProfile>({ required: true });
const props = defineProps<{ idPrefix: string }>();
const id = (k: string) => `${props.idPrefix}-${k}`;
</script>

<template>
  <div class="bf">
    <div class="kind">
      <label class="opt" :class="{ on: model.kind === 'company' }">
        <input v-model="model.kind" type="radio" value="company"> <Icon name="building" /> Firma
      </label>
      <label class="opt" :class="{ on: model.kind === 'person' }">
        <input v-model="model.kind" type="radio" value="person"> <Icon name="user" /> Osoba prywatna
      </label>
    </div>

    <div class="field">
      <label :for="id('name')">{{ model.kind === "company" ? "Nazwa firmy" : "Imię i nazwisko" }}</label>
      <input :id="id('name')" v-model="model.name" type="text" maxlength="200" autocomplete="organization" required>
    </div>

    <div v-if="model.kind === 'company'" class="field">
      <label :for="id('nip')">NIP</label>
      <input :id="id('nip')" v-model="model.nip" type="text" inputmode="numeric" maxlength="13" placeholder="000-000-00-00" required>
    </div>

    <div class="field">
      <label :for="id('address')">Ulica i numer</label>
      <input :id="id('address')" v-model="model.address" type="text" maxlength="200" autocomplete="street-address" required>
    </div>

    <div class="row">
      <div class="field" style="flex:1">
        <label :for="id('postal')">Kod pocztowy</label>
        <input :id="id('postal')" v-model="model.postalCode" type="text" maxlength="12" :placeholder="model.country === 'PL' ? '00-000' : ''" autocomplete="postal-code" required>
      </div>
      <div class="field grow" style="flex:2">
        <label :for="id('city')">Miejscowość</label>
        <input :id="id('city')" v-model="model.city" type="text" maxlength="100" autocomplete="address-level2" required>
      </div>
      <div class="field" style="flex:0 0 80px">
        <label :for="id('country')">Kraj</label>
        <input :id="id('country')" v-model="model.country" type="text" maxlength="2" autocapitalize="characters" autocomplete="country">
      </div>
    </div>

    <div class="field">
      <label :for="id('iemail')">E-mail do faktur <span class="muted">(opcjonalnie, gdy inny niż login)</span></label>
      <input :id="id('iemail')" v-model="model.invoiceEmail" type="email" maxlength="254" autocomplete="email">
    </div>
  </div>
</template>

<style scoped>
.kind { display: flex; gap: var(--s2); margin: var(--s3) 0; }
.opt {
  flex: 1; display: flex; align-items: center; gap: 8px; padding: 10px 12px; border: 1px solid var(--bd2);
  border-radius: var(--r1); cursor: pointer; font-size: 13px; font-weight: 550; background: var(--bg);
}
.opt.on { border-color: var(--acc); background: var(--acc-dim); }
.opt input { width: auto; margin: 0; }
.bf :deep(.field) { margin: var(--s2) 0; }
</style>
